import { IconButton, Menu, MenuItem, ListItemText, Tooltip, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import React from 'react';
import i18n from '../i18n';

const languages = [
    { code: 'en', label: 'English', abbrev: 'eng' },
    { code: 'zh-TW', label: '繁體中文', abbrev: '繁' },
    { code: 'zh-CN', label: '简体中文', abbrev: '简' },
];

const LanguageSwitch: React.FC = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const changeLanguage = async (lng: string) => {
        await i18n.changeLanguage(lng);
        localStorage.setItem('i18nextLng', lng);
        handleClose();
    };

    const currentLang = (() => {
        const found = languages.find(l => l.code === i18n.language);
        if (found) return found.abbrev;
        // handle cases like en-US
        const base = i18n.language.split('-')[0];
        if (base === 'en') return 'eng';
        if (base === 'zh') return '繁';
        return 'eng';
    })();

    return (
        <>
            <Tooltip title="Language">
                <IconButton onClick={handleOpen} size="small" sx={{ color: 'black', width: 52, height: 40, display: 'flex', gap: 0.5 }} aria-label="language switch" aria-expanded={open}>
                    {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                    <Box sx={{ fontSize: 14, fontWeight: 600, textTransform: 'uppercase', lineHeight: 1 }}>{currentLang}</Box>
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
                {languages.map((lng) => (
                    <MenuItem key={lng.code} onClick={() => changeLanguage(lng.code)} selected={i18n.language === lng.code}>
                        <ListItemText primary={lng.label} secondary={lng.code.toUpperCase()} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default LanguageSwitch;
